import { createFileRoute } from "@tanstack/react-router";
import AdminPanel from "@/components/AdminPanel";
import { AccessDenied, LoadingState } from "@/components/admin/_shared/AdminStates";
import { useAuth } from "@/hooks/useAuth";

export const ADMIN_TABS = ["users", "settings", "billing", "integrations"] as const;
export type AdminTab = (typeof ADMIN_TABS)[number];

export const DEFAULT_ADMIN_TAB: AdminTab = "users";

const isAdminTab = (value: unknown): value is AdminTab =>
  typeof value === "string" && (ADMIN_TABS as readonly string[]).includes(value);

interface AdminSearch {
  tab?: AdminTab;
}

export const Route = createFileRoute("/_authenticated/admin")({
  validateSearch: (search: Record<string, unknown>): AdminSearch =>
    isAdminTab(search.tab) ? { tab: search.tab } : {},
  component: AdminRoute,
});

function AdminRoute() {
  const { user, isLoading } = useAuth();

  if (isLoading) return <LoadingState minHeight="50vh" />;

  const hasAdminAccess = user?.role === "admin" || user?.role === "superadmin";
  if (!hasAdminAccess) return <AccessDenied />;

  return <AdminPanel />;
}
